import { render } from "./App.vue?vue&type=template&id=ac8f5782&bindings={\"changetop\":\"data\",\"hastotop\":\"data\",\"closetop\":\"data\",\"handleScroll\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script